import { render, staticRenderFns } from "./Addstorage.vue?vue&type=template&id=7af1b499&scoped=true&"
import script from "./Addstorage.vue?vue&type=script&lang=js&"
export * from "./Addstorage.vue?vue&type=script&lang=js&"
import style0 from "./Addstorage.vue?vue&type=style&index=0&id=7af1b499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af1b499",
  null
  
)

export default component.exports